// extracted by mini-css-extract-plugin
export default {"wrapper":"StoresTile_wrapper__o42JF","stores":"StoresTile_stores__+AYRf","wrapperItems":"StoresTile_wrapperItems__h2PRW","items":"StoresTile_items__GxchX"};